import { render, staticRenderFns } from "./LmFormEmptySpace.vue?vue&type=template&id=f0156d24&scoped=true"
import script from "./LmFormEmptySpace.vue?vue&type=script&lang=js"
export * from "./LmFormEmptySpace.vue?vue&type=script&lang=js"
import style0 from "./LmFormEmptySpace.vue?vue&type=style&index=0&id=f0156d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0156d24",
  null
  
)

export default component.exports